import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { CoverageSection } from "@/components/CoverageSection";
import { PhotoLibrarySection } from "@/components/PhotoLibrarySection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { EnquiryModal } from "@/components/EnquiryModal";

export default function HomePage() {
  const [enquiry, setEnquiry] = useState({ open: false, service: null });
  const location = useLocation();

  const openEnquiry = (service = null) => setEnquiry({ open: true, service });

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToSection(location.state.scrollTo), 450);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div data-testid="home-page">
      <Navbar onEnquire={() => openEnquiry()} />
      <Hero onEnquire={() => openEnquiry()} />
      <Marquee />
      <CoverageSection />
      <PhotoLibrarySection onEnquire={openEnquiry} />
      <ContactSection />
      <Footer />
      <EnquiryModal
        open={enquiry.open}
        service={enquiry.service}
        onClose={() => setEnquiry({ open: false, service: null })}
      />
    </div>
  );
}
